import GetProviderDisplayName from '../../../../components/data-driven-logo/get-provider-display-name';

const useSellerLabelProviderGroups = (availableServices) => {
  const services = availableServices.filter((service) => !service.isHidden);

  const servicesByLabelProvider = services.reduce((groups, service) => {
    const group = groups[service.sellerLabelProviderId];
    if (!group) {
      return {
        ...groups,
        [service.sellerLabelProviderId]: {
          carrierId: service.carrierId,
          groupId: service.sellerLabelProviderId,
          name: GetProviderDisplayName(service.labelProviderId),
          items: [service],
        },
      };
    }

    return {
      ...groups,
      [service.sellerLabelProviderId]: {
        ...group,
        items: [...group.items, service],
      },
    };
  }, {});

  return Object.keys(servicesByLabelProvider)
    .map((key) => servicesByLabelProvider[key])
    .sort((a, b) => Number.parseInt(a.carrierId, 10) - Number.parseInt(b.carrierId, 10));
};

export default useSellerLabelProviderGroups;
